export function getTheme(theme) {
  return theme === 'light' ? {
    bg: '#f0f0eb', sidebar: '#ffffff', border: '#e0e0d8',
    card: '#ffffff', cardBorder: '#e0e0d8',
    text: '#1a1a1a', textSub: '#777', textMuted: '#bbb',
    input: '#f8f8f4', inputBorder: '#d0d0c8',
    nav: '#f0f0eb', navActive: '#1a2336', navBorder: '#1a2336',
    tableHead: '#888', tableRow: '#e8e8e2', tableText: '#333',
    badge: '#e8e8e2', badgeText: '#444',
    kpiCard: '#ffffff', kpiText: '#1a1a1a',
    noteBox: '#f4f4ef', noteText: '#333',
    btnPrimary: '#1a2336', btnPrimaryText: '#ffffff',
    btnSecondary: '#e8e8e2', btnSecondaryText: '#444', btnSecondaryBorder: '#d0d0c8',
    filterActive: '#1a2336', filterActiveText: '#ffffff',
    filterInactive: 'transparent', filterInactiveText: '#777', filterBorder: '#d0d0c8',
    panelBg: '#ffffff', panelBorder: '#e0e0d8',
    infoItem: '#f4f4ef', section: '#ffffff',
    topbar: '#f0f0eb', chartCard: '#ffffff', barTrack: '#e8e8e2', emptyRow: '#777',
    searchIcon: '#aaa', rowHover: '#f4f4ef', rowActive: '#e8f0ff',
  } : {
    bg: '#111827', sidebar: '#1a2336', border: '#243050',
    card: '#1a2336', cardBorder: '#243050',
    text: '#e8e4dc', textSub: '#5a6a8a', textMuted: '#2e3d58',
    input: '#243050', inputBorder: '#2e3d58',
    nav: '#243050', navActive: '#e8e4dc', navBorder: '#e67e22',
    tableHead: '#4a5a7a', tableRow: '#1e2a40', tableText: '#ccd0dc',
    badge: '#243050', badgeText: '#8a9ab8',
    kpiCard: '#1a2336', kpiText: '#e8e4dc',
    noteBox: '#1e2a40', noteText: '#9aa8c0',
    btnPrimary: '#e67e22', btnPrimaryText: '#ffffff',
    btnSecondary: 'transparent', btnSecondaryText: '#8a9ab8', btnSecondaryBorder: '#2e3d58',
    filterActive: '#e67e22', filterActiveText: '#ffffff',
    filterInactive: 'transparent', filterInactiveText: '#5a6a8a', filterBorder: '#2e3d58',
    panelBg: '#1a2336', panelBorder: '#243050',
    infoItem: '#1e2a40', section: '#1a2336',
    topbar: '#111827', chartCard: '#1a2336', barTrack: '#243050', emptyRow: '#4a5a7a',
    searchIcon: '#4a5a7a', rowHover: '#1e2a40', rowActive: '#1e2a40',
  };
}
